module.exports = __webpack_public_path__ + "img/undo.25fc2224.svg";